import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Router, NavigationEnd } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.sass']
})

export class AppComponent implements OnInit  {

  translate: TranslateService;
  router : Router;

  constructor(translate: TranslateService, router : Router) {
    // this language will be used as a fallback when a translation isn't found in the current language
    translate.setDefaultLang('es');

    // the lang to use, if the lang isn't available, it will use the current loader to get them
    //translate.use('en');

    this.translate = translate;
    this.router = router;


    //(<any>window).jQuery("body").smoove({
		  //offset  : '15%',
		  // moveX is overridden to -200px for ".bar" object
		  //moveX   : '100px',
		  //moveY   : '100px',
		//});
  }

  changeLanguage (lang: string) {
    this.translate.use(lang);
    //console.log("Changed language to ", lang)
  }

  ngOnInit() {

    this.router.events.subscribe((evt) => {
        if (!(evt instanceof NavigationEnd)) {
            return;
        }

        if(!this.router.url.includes("index")) {
          window.scrollTo(0, 0)
        }
        if(this.router.url.includes("services")) {
          let el = document.getElementById("services");
          el.scrollIntoView();
        }
        if(this.router.url.includes("works")) {
          let el = document.getElementById("works");
          el.scrollIntoView();
        }
        if(this.router.url.includes("curriculum")) {
          let el = document.getElementById("curriculum");
          el.scrollIntoView();
          // window.scrollTo(0, 1818)
        }
        if(this.router.url.includes("contact")) {
          let el = document.getElementById("contact");
          el.scrollIntoView();
        }

    });
}
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts